module.exports = __webpack_public_path__ + "img/1500711758.0bbeff45.jpg";